import { UTCDate } from '@/utils/dates';
import { ChevronLeft } from 'lucide-react';
import { Button } from '../../../design-system/button/button';
import { Inline } from '../../../design-system/inline/inline';
import { Stack } from '../../../design-system/stack/stack';
import { AllowedOAuthProvider, OAuthConnectionInformation } from '../types/types';
import { ConnectedOAuthProviderCard } from './connected-oauth-provider-card';

type ConnectedOAuthProviderWrapperProps = {
  provider: AllowedOAuthProvider;
  connectionStatus: OAuthConnectionInformation;
  onGoBack: () => void;
  onDisconnect: () => void;
};

export const ConnectedOAuthProviderWrapper = ({
  provider,
  connectionStatus,
  onGoBack,
  onDisconnect,
}: ConnectedOAuthProviderWrapperProps) => {
  const capitalizedProvider = provider.charAt(0).toUpperCase() + provider.slice(1);
  const lastVerifiedAt = connectionStatus.lastVerifiedAt ? new UTCDate(connectionStatus.lastVerifiedAt) : undefined;

  return (
    <Stack space={10} align="stretch" className="px-6 pt-4">
      <Inline space={4}>
        <Button variant="ghost" size="icon" aria-label="Return to integrations page" onClick={onGoBack}>
          <div className="h-10 w-10 rounded-full bg-muted p-2">
            <ChevronLeft className="h-full w-full" />
          </div>
        </Button>

        <Stack>
          <p className="text-xs leading-5 font-normal tracking-tight text-muted-foreground">Integrations</p>

          <h3 className="text-2xl leading-5 font-semibold tracking-tight text-black">{capitalizedProvider}</h3>
        </Stack>
      </Inline>

      <ConnectedOAuthProviderCard
        provider={provider}
        displayName={connectionStatus?.email}
        connectionDate={lastVerifiedAt}
        onDisconnect={onDisconnect}
      />
    </Stack>
  );
};
